'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Discover = require('./Discover.scss');

var _Discover2 = _interopRequireDefault(_Discover);

var _reactBootstrap = require('react-bootstrap');

var _lib = require('helpers/lib');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AreasFilter = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(AreasFilter, _Component);

  function AreasFilter() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, AreasFilter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AreasFilter.__proto__ || (0, _getPrototypeOf2.default)(AreasFilter)).call.apply(_ref, [this].concat(args))), _this), _this.hanldeCheckedAddress = function (event) {
      _this.props.hanldeCheckedAddress(event);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(AreasFilter, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          districts = _props.districts,
          addressFilter = _props.addressFilter;

      var areas = [];
      if (districts && districts.length > 0) {
        for (var index = 0; index < districts.length; index++) {
          var code = districts[index].code;
          areas.push(_react2.default.createElement(
            'li',
            { key: String(index) },
            addressFilter.indexOf(String(code)) !== -1 ? _react2.default.createElement('input', {
              type: 'checkbox',
              ref: 'addressFilter',
              id: code,
              name: code,
              onChange: this.hanldeCheckedAddress,
              checked: true
            }) : _react2.default.createElement('input', {
              type: 'checkbox',
              ref: 'addressFilter',
              id: code,
              name: code,
              onChange: this.hanldeCheckedAddress
            }),
            _react2.default.createElement(
              'label',
              { htmlFor: code },
              (0, _lib.typeAreaAbbreviation)(districts[index].type) + districts[index].name
            )
          ));
        }
      }
      return _react2.default.createElement(
        'div',
        { className: _Discover2.default.area },
        _react2.default.createElement(
          'div',
          { className: _Discover2.default.titleTypes },
          _react2.default.createElement(_reactBootstrap.Glyphicon, { className: _Discover2.default.icon, glyph: 'map-marker' }),
          'Khu v\u1EF1c'
        ),
        _react2.default.createElement(
          'ul',
          { className: _Discover2.default.subList },
          areas
        )
      );
    }
  }]);
  return AreasFilter;
}(_react.Component), _class.propTypes = {
  districts: _react.PropTypes.array,
  addressFilter: _react.PropTypes.array,
  hanldeCheckedAddress: _react.PropTypes.func.isRequired
}, _temp2);
exports.default = AreasFilter;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Discover/AreasFilter.js
// module id = 1671
// module chunks = 0